/**
 * About / Team section — Doctor+Mattress
 * Handles the rotating badge's motion-safety behavior:
 *  - Respects prefers-reduced-motion (and live changes to it)
 *  - Pauses the spin on hover/focus so it doesn't distract while reading
 *
 * Include this after the CSS, once per page. It's safe to include even
 * if the section isn't present — it just no-ops.
 */
(function () {
  'use strict';

  function initAboutTeamSection(section) {
    var badge = section.querySelector('.rotate-badge .spin');
    if (!badge) return;

    var reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    function syncReducedMotion(mq) {
      section.classList.toggle('at-reduced-motion', mq.matches);
    }

    syncReducedMotion(reduceMotionQuery);

    // Older Safari uses addListener/removeListener instead of the
    // EventTarget API for MediaQueryList.
    if (typeof reduceMotionQuery.addEventListener === 'function') {
      reduceMotionQuery.addEventListener('change', syncReducedMotion);
    } else if (typeof reduceMotionQuery.addListener === 'function') {
      reduceMotionQuery.addListener(syncReducedMotion);
    }

    // Pause the spin on hover/focus within the media block, resume on leave.
    var media = section.querySelector('.about-media');
    if (!media) return;

    var pause = function () { badge.style.animationPlayState = 'paused'; };
    var resume = function () {
      if (!section.classList.contains('at-reduced-motion')) {
        badge.style.animationPlayState = 'running';
      }
    };

    media.addEventListener('mouseenter', pause);
    media.addEventListener('mouseleave', resume);
    media.addEventListener('focusin', pause);
    media.addEventListener('focusout', resume);
  }

  function init() {
    var sections = document.querySelectorAll('.about-team-section');
    sections.forEach(initAboutTeamSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when Shopify's theme editor swaps section HTML in/out.
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.about-team-section');
    if (section) initAboutTeamSection(section);
  });
})();
